<template>
  <div style="height: 100%;">
    <app-base-main parentTable v-show="mainVisible">
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery"
        >
          <gj-select
              v-model="filter.statusList"
              :options="option.status"
              type="multi-check"
              placeholder="状态"
              width="155px"
          ></gj-select>
          <gj-select
              v-model="filter.quote"
              placeholder="是否报价"
              :options="[
                  {id: 1, text: '是'},
                  {id: 0, text: '否'}
              ]"
              width="100px"
          ></gj-select>
          <gj-select
              v-model="filter.urgent"
              placeholder="是否加急"
              :options="[
                  {id: 1, text: '是'},
                  {id: 0, text: '否'}
              ]"
              width="100px"
          ></gj-select>
          <gj-select-date-picker
              v-model="filter.date"
              :options="option.date"
              type="daterange"
          ></gj-select-date-picker>
          <gj-select-input
              v-model="filter.keyword"
              :options="option.keyword"
          >
          </gj-select-input>
          <template #right>
            <view-setting
                :ref="REF_VIEW_SETTING"
                save-mode="remote"
                :use-default="true"
                :module-name="moduleName"
                :config="model"
                :fn-generate-params="generateViewParams"
                @view-change="handleChangeView"
                @view-complete="handCompleteView"
            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button type="primary" @click="add">添加</gj-button>
        <gj-select
            class="selected-active"
            v-model="batchOperate"
            :options="option.batchOperation"
            @input="changeOperate"
            placeholder="批量操作"
            width="100px"
        ></gj-select>
        <gj-button @click="createPurchaseOrder(selectedRows)" v-if="$permission('purchasePlan:generatePurchaseOrder')">
          生成采购单
        </gj-button>
      </template>
      <template #tool-group>
        <div class="tools-tips">
          <gj-tool-group
              :download="$permission('purchasePlan:export')"
              download-url="/supply/purchasePlan/export"
              :download-params="globalParams"
              help
          ></gj-tool-group>
        </div>
      </template>
      <template #table>
        <gj-table
            selection
            adaptParent
            ref="gjTable"
            :columns="columns"
            :data="tableData"
            :index="false"
            name="purchasePlan"
            :bak-selected-rows="bakSelectedRows"
            @clearBakSelectedRows="clearBakRows"
            @openDetail="openDetail"
            :bak-rows="selectedRows"
            :child-selection="true"
            :selectable="(row) => !row.$gjExtendRow"
            :extend-row-config="{prop: 'extendRow'}"
            :structure-config="{type: 'ParentChild', children: 'products', parentSpan: [1, 12]}"
            :default-sort="{prop:'createTime', order:'ascending'}"
            :pagination="pagination"
            :loading="loading"
            :show-overflow="false"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        >
          <template v-slot:purchasePlanCode="{row}">
            <template v-if="row.$gjParentData">
              <span style="display: inline-block;width: 150px">
                 <span class="title-span">创建人：</span> <span>{{ row.createUserName | defaultShow }}</span>
              </span>
              <span style="display: inline-block;width: 240px">
                <span class="title-span">创建时间：</span><span>{{ row.createTime | defaultShow }}</span>
            </span>
              <span style="display: inline-block;width: 300px">
                 <app-delivery-plan-desc
                     :value="row.memo"
                     :item="row"
                     :prefixText="'备注：'"
                     :show-prefix="true"
                     fixedIcon
                     table-cell-edit
                     :on-confirm="confirmEditMemo"
                     :pop-title="'备注编辑'">
                  </app-delivery-plan-desc>
            </span>
              <span style="display: inline-block;width: 280px" v-if="row.attachments && row.attachments.length > 0">
                <el-popover placement="bottom" width="256" popper-class="gj-popover" trigger="hover">
                  <template v-for="(item,index) in row.attachments">
                     <div :key="index" class="popover-content">
                        <span @click="downLoadFile(item.id)">
                            <i class="el-icon-paperclip"></i>&nbsp;&nbsp;
                          <gj-text max-width="160px">{{ item.fileName }}</gj-text>
                       </span>
                       <gj-button type="text" @click="deleteFile(item.id,item)" :loading="item.delLoading">
                           <i class="el-icon-delete" style="cursor: pointer;"></i>
                       </gj-button>
                     </div>
                  </template>
                    <span style="display: flex;width: 260px;align-items: center" slot="reference">
                          <span @click="downLoadFile(row.attachments[0].id)" style="cursor: pointer">
                            <gj-text max-width="255px">
                              <span class="title-span"> 附件： </span>
                              <i class="el-icon-paperclip">{{ row.attachments.length }}</i>
                              &nbsp;&nbsp;{{ row.attachments[0].fileName }}
                            </gj-text>
                          </span>
                      <i class="el-icon-arrow-down" v-if="row.attachments.length > 1" style="margin-left: 10px"></i>
                   </span>
                </el-popover>
            </span>
              <span style="display: inline-block;width: 200px">
               <div style="display: flex;align-items: center" class="purchase-plan-accessory">
                   <span v-if="!row.attachments">附件：</span>
                  <gj-upload
                      :disabled="row.attachments && row.attachments.length >= 5"
                      class="gj-upload-text"
                      upload-btn-type="text"
                      @uploadAfter="onFileSuccess(row)"
                      :beforeUpload="handleExceed"
                      :show-file-list="false"
                      :valid-file-size="10"
                      :container-biz-id="transferOrder ? transferOrder.id : null"
                      container-type="PURCHASE_PLAN"
                      :text="'上传'"
                      :fileList.sync="form.files"
                  ></gj-upload>
               </div>
            </span>
            </template>
            <template v-else>
              {{ row.purchasePlanCode }}
              <span v-if="row.urgent" class="urgent-text">急</span>
              <span v-if="row.productType === 'Assembly'" class="type-text">组</span>
            </template>
          </template>
          <template v-slot:productName="{ row }">
            <div class="default" v-if="!row.$gjParentData">
              <gj-tooltip class="value" style="flex: 1" :text-line="1" :content="row.productName">{{
                  row.productName
                }}
              </gj-tooltip>
              <br>
              <gj-text max-width="84%">{{ row.sku | defaultShow }}</gj-text>
              <span v-if="row.sku" v-copy="row.sku" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
            </div>
          </template>
          <template v-slot:memo="{row}">
            <gj-text width="90%">{{ row.memo | defaultShow }}</gj-text>
          </template>

          <template v-slot:status="{row}">
            <template v-if="!row.$gjParentData">
              <gj-tag type="plain" style="margin-right: 10px" shape="rectangle"
                      :color="row.status | optionColor(PurchasePlanEnum.statusOption)">
                {{ row.status | optionText(PurchasePlanEnum.statusOption) }}
              </gj-tag>
            </template>
          </template>

          <template v-slot:op="{ row }">
            <template v-if="!row.$gjParentData">
              <gj-button-group
                  :show-length="1"
                  type="dropdown-op"
                  :config="opBtnConfig(row)"
              ></gj-button-group>
            </template>
          </template>
          <template v-slot:extend:row="{row}">
            <div class="default">
              <div v-if="!row.expand">
                <gj-link type="default" @click="openDetail(row,true)">
                  更多（共{{ row.num }}条）
                  <i class="iconfont iconzhankai"></i>
                </gj-link>
              </div>
              <div v-else>
                <gj-link type="default" @click="openDetail(row, false)">
                  收起
                  <i class="iconfont iconshouqi"></i>
                </gj-link>
              </div>
            </div>
          </template>
        </gj-table>
      </template>
    </app-base-main>
    <op-purchase-plan-add v-if="!mainVisible" :opType="opType" :rows="propRows" :type="type"
                          @closeOpen="toggleVisible"></op-purchase-plan-add>
  </div>


</template>

<script>
import {queryMixin, responseMixin, selectionMixin, valueCheckMixin} from "@/minxins";
import {convertToDate, generateViewParams} from "@/utils/date.util";
import {defaultVal, isMeaningful} from "@/utils/common";
import {PurchasePlanEnum} from "./enum";
import model from './viewConfig'
import {OpEnum} from "@/utils/options";
import {
  getPurchasePlanPage, purchasePlanReviewYes, purchasePlanArraignment,
  deletePurchasePlan, purchasePlanUpdateAttachment, queryReviewSetting, purchasePlanUpdateInfo
} from "@/api/purchase";
import AppPurchasePlanModal from "./components/purchase-plan-modal";
import AppPurchasePlanDesc from "./components/purchase-plan-desc"
import AppPurchasePlanCreateOrder from "./modal/op-purchase-plan-create-order"
import {downloadAttFile, removeAttachmentById} from "@/api/common";
import OpPurchasePlanAdd from './modal/op-purchase-plan-add'
import GjLogModal from "@/components/modal/gj-log-modal";
import {FileTypeEnum} from "@/components/upload/enum"
import AppDeliveryPlanDesc from '../../logistics/delivery-plan/modal/delivery-plan-desc'

const StatusEnum = PurchasePlanEnum.status;

export default {
  name: "purchase-plan",
  mixins: [queryMixin, selectionMixin, responseMixin, valueCheckMixin],
  components: {OpPurchasePlanAdd, AppDeliveryPlanDesc},
  data() {
    return {
      PurchasePlanEnum,
      FileTypeEnum,
      moduleName: 'PURCHASE_PLAN',
      bakSelectedRows: [],
      filter: {
        statusList: ['processing'],
        keyword: {
          key: 'purchasePlanCode',
          value: ''
        },
        date: {
          key: 'createTime',
          value: null,
        },
      },
      opType: '',
      propRows: [],
      mainVisible: true,
      batchOperate: '',
      columns: [
        {id: 'purchasePlanCode', header: '计划编号', field: 'slot:purchasePlanCode', width: '190px', default: true},
        {id: 'smallImageUrl', header: '图片', field: 'picture:smallImageUrl', width: '60px', default: true},
        {
          id: 'productName',
          header: '产品名称/SKU',
          field: 'slot:productName',
          minWidth: '160px',
          default: true,
          sortBy: 'sku'
        },
        {
          id: 'quote',
          header: '是否报价',
          field: 'option:quote',
          options: [{id: true, text: '是'}, {id: false, text: '否'}],
          minWidth: '90px',
          default: true
        },
        {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', minWidth: '140px', default: true},
        {id: 'planQuantity', header: '计划采购量', field: 'planQuantity', minWidth: '120px', default: true},
        {
          id: 'planDeliveryDate',
          header: '计划交期', field: 'planDeliveryDate', minWidth: '155px', default: true
        },
        {id: 'deliveryWarehouseName', header: '目的仓库', field: 'deliveryWarehouseName', minWidth: '100px', default: true},
        {id: 'reviewUserName', header: '审核人', field: 'reviewUserName', minWidth: '100px', default: true},
        {id: 'reviewTime', header: '审核时间', field: 'reviewTime', minWidth: '155px', default: true},
        {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '120px', default: true},
        {id: 'status', header: '状态', field: 'slot:status', width: '80px', default: true},
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '110px', fixed: 'right', default: true},
      ],
      tableData: [],
      transferOrder: {},
      form: {
        files: [],
      },
      type: '',
      downloadVisible: false,
      option: {
        status: PurchasePlanEnum.statusOption,
        batchOperation: PurchasePlanEnum.batchOperation,
        PurchasePlanEnum: PurchasePlanEnum,
        keyword: PurchasePlanEnum.keyWord,
        date: [
          {id: 'createTime', text: '创建时间'},
          {id: 'reviewTime', text: '审核时间'},
        ]
      },
      opBtnConfig: (row) => [
        {
          label: '编辑',
          show: () => this.$permission('purchasePlan:add') && this.someIs(row.status, [StatusEnum.DRAFT, StatusEnum.REJECTED, StatusEnum.WAIT_HANDLE]),
          click: () => this.batchEdit([{...row}], 'one')
        },
        {
          label: '提审',
          show: () => this.$permission('purchasePlan:add') && this.someIs(row.status, [StatusEnum.REJECTED, StatusEnum.DRAFT]),
          click: () => this.pushReview([{...row}])
        },
        {
          label: '删除',
          show: () => this.$permission('purchasePlan:add') && row.status === StatusEnum.DRAFT,
          click: () => this.batchDelete([{...row}])
        },
        {
          label: '审核通过',
          show: () => this.$permission('purchasePlan:audit') && row.status === StatusEnum.WAIT_REVIEW,
          click: () => this.batchPass([{...row}])
        },
        {
          label: '审核驳回',
          show: () => this.$permission('purchasePlan:audit') && row.status === StatusEnum.WAIT_REVIEW,
          click: () => this.batchReject([{...row}], 'reject')
        },
        {
          label: '作废',
          show: () => this.$permission('purchasePlan:abolish') && this.someIs(row.status, [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED, StatusEnum.WAIT_HANDLE]),
          click: () => this.batchReject([{...row}], StatusEnum.ABOLISHED)
        },
        {
          label: '日志',
          show: () => true,
          click: () => this.openLog(row)
        }
      ],
      model,
      downloadLoading: false
    }
  },
  created() {
    this.sort.prop = 'createTime';
    this.queryOptionShow()
  },
  methods: {
    $gjQuery() {
      this.selectedRows = [];
      this.clearBakRows();
      const params = {
        model: {
          quote: this.filter.quote,
          urgent: this.filter.urgent,
          statusList: this.filter.statusList,
          [this.filter.keyword.key]: this.filter.keyword.value,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      if (isMeaningful(this.filter.date.value)) {
        if (this.filter.date.key === 'createTime') {
          params.model.startCreateTime = convertToDate(this.filter.date.value[0]);
          params.model.endCreateTime = convertToDate(this.filter.date.value[1]);
        } else if (this.filter.date.key === 'reviewTime') {
          params.model.startReviewTime = convertToDate(this.filter.date.value[0]);
          params.model.endReviewTime = convertToDate(this.filter.date.value[1]);
        }
      }
      this.globalParams = params
      this.loading = true;
      getPurchasePlanPage(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              const products = this._.cloneDeep(v.products) || [];
              v.downloadVisible = false
              let parentKey = Math.floor(Math.random() * (999999 - 100000)) + 100000;
              v.$gjParentKey = parentKey;
              products.forEach(item => {
                item.$gjChildKey = parentKey;
                item.$gjChildData = true;
              })
              return Object.assign(v, {
                productsCopy: products,
                products: products.length > 3 ? products.slice(0, 3) : products,
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
    },
    queryOptionShow() {
      queryReviewSetting({name: 'PURCHASE_PLAN_REVIEW_SETTING'}).then(res => {
        if (!res) {
          this.option.batchOperation = PurchasePlanEnum.batchOperationClose;
        }
      })
    },
    onFileSuccess(row) {
      if (!row || this.form.files.length === 0) return;
      this.uploadFiles(row)
    },
    uploadFiles(row) {
      purchasePlanUpdateAttachment({
        attachmentIds: this.form.files.map(item => item.attId),
        id: row.id
      }).then(() => {
        this.form.files = [];
        this.$gjMessage.success("上传文件成功！");
        this.$gjQuery();
      })
    },
    downLoadFile(id) {
      if (!id) return;
      downloadAttFile(id).then(() => {
      });
    },
    deleteFile(attId, file) {
      if (isMeaningful(attId)) {
        file.delLoading = true;
        removeAttachmentById(attId)
            .then(() => {
              this.$message.success("删除成功！");
              this.$gjQuery();
            }).complete(() => {
          file.delLoading = false;
        });
      }
    },
    generateViewParams,
    loadViewComplete() {
      this.$emit('query')
    },

    $gjQueryInitParams() {
      return {
        filter: {
          statusList: ['processing'],
          keyword: {
            key: 'purchasePlanCode',
            value: null
          },
          urgent: null,
          quote: null,
          date: {
            key: 'createTime',
            value: []
          },
        },
      };
    },
    createPurchaseOrder(rows) {
      if (rows.length === 0) {
        this.$gjMessage.warning("请勾选需要操作的数据")
        return false;
      }
      if (this.selectedSomeIsNot('status', PurchasePlanEnum.status.WAIT_HANDLE)) {
        this.$gjMessage.warning("只有待处理状态的才能生成采购单")
        return false;
      }
      this.$gjCreate(AppPurchasePlanCreateOrder, {
        props: {
          rows: rows,
        },
        on: {
          updated: () => {
            this.$gjResetPage();
          }
        }
      })
    },
    // 提审
    pushReview(rows) {
      purchasePlanArraignment({
        idList: rows.map(e => e.purchasePlanId),
      })
          .then(res => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
              this.$gjResetPage();
            });
          })
    },
    batchDelete(rows) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '删除确认',
          content: rows.length === 1
              ? `是否要删除采购计划，删除后无法恢复？`
              : `已选中 ${rows.length} 个采购计划，是否要删除采购计划，删除后无法恢复？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            deletePurchasePlan({idList: rows.map(v => v.purchasePlanId)})
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false)
          }
        }
      });
    },
    batchPass(rows) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '审核确认',
          content: rows.length === 1
              ? `是否通过审核？`
              : `已选中 ${rows.length} 个采购计划，是否批量通过审核？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            purchasePlanReviewYes({idList: rows.map(v => v.purchasePlanId)})
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false)
          }
        }
      });
    },
    batchReject(rows = [], type) {
      let title = type === 'reject' ? '驳回' : '作废';
      let label = type === 'reject' ? '驳回理由' : '作废理由';
      this.$gjCreate(AppPurchasePlanModal, {
        props: {title, label, rows, type},
        on: {
          updated: () => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
          }
        },
      });
    },
    confirmEditMemo(val, row, closeEditor, closeLoading) {
      if (val && val.length <= 200) {
        this.confirmLoading = true;
        purchasePlanUpdateInfo({
          id: row.id,
          memo: defaultVal(val, " "),
        }).then(() => {
          this.$gjMessage.success('操作成功');
          closeEditor();
          this.$gjResetPage();
        }).complete(() => closeLoading());
      } else {
        this.$gjMessage.error("请输入备注，且不能超过200个字符")
      }
    },
    hidePopover() {
      document.body.click()
    },
    handleExceed() {
      if (this.form.files.length > 5) {
        this.$gjMessage.error("上传失败，失败原因：附件不超过10M，最大支持上传5个附件")
        return false;
      }
      return true;
    },
    clearBakRows() {
      this.bakSelectedRows = [];
    },
    editDesc(row) {
      this.$gjCreate(AppPurchasePlanDesc, {
        props: {
          row: row,
        },
        on: {
          updated: () => {
            this.$gjResetPage();
          }
        }
      })
    },
    batchEdit(rows, type) {
      this.mainVisible = false;
      this.opType = OpEnum.type.UPDATE;
      this.type = type;
      this.propRows = rows;
    },
    add() {
      this.mainVisible = false;
      this.opType = OpEnum.type.ADD;
    },
    toggleVisible(val) {
      if (val === 'refresh') this.$gjResetPage();
      this.mainVisible = true;
      this.$nextTick(() => {
        this.$gjSelectionListened = undefined;
        this.listenSelection();
      })
    },
    openDetail(row, flag) {
      if (flag) {
        row.products = row.productsCopy;
        row.expand = flag;
      } else {
        row.products = row.products.slice(0, 3);
        row.expand = flag;
      }
      this.tableData = this.tableData.map(v => {
        if (v.id === row.id) {
          v.expand = row.expand
          v.products = row.products
        }
        return v
      })
      this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
    },
    openLog(row) {
      this.$gjCreate(GjLogModal, {
        props: {
          url: '/supply/purchasePlan/get/log/page',
          params: {
            model: row.purchasePlanId
          },
          columns: [
            {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
            {id: 'createUserName', header: '操作用户', field: 'createUserName', minWidth: '100px'},
            {
              id: 'op', header: '操作分类', field: 'option:op', options: [
                {id: 'save', text: '保存为草稿'},
                {id: 'update', text: '更新'},
                {id: 'saveArraignment', text: '新增'},
                {id: 'arraignment', text: '提审'},
                {id: 'reviewYes', text: '审核通过'},
                {id: 'reviewNo', text: '审核不通过'},
                {id: 'createPurchaseOrder', text: '生成采购订单'},
                {id: 'abolished', text: '作废'},
                {id: 'delete', text: '删除'},
              ], minWidth: '120px'
            },
            {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '350px'}
          ],

        }
      })
    },
    changeOperate() {
      // this.selectedRows = this.selectedRows.filter(item => !item.$gjChildData)
      if (this.selectedRows.length === 0) {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        this.$gjMessage.warning("请勾选需要操作的采购计划！");
        return false;
      }
      if (this.batchOperate === 'edit') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.REJECTED, StatusEnum.DRAFT, StatusEnum.WAIT_HANDLE])) {
          this.$gjMessage.warning("草稿、已驳回、待处理状态下的采购计划才能编辑！")
          return false;
        }
        this.batchEdit(this.selectedRows, 'batch');
      } else if (this.batchOperate === 'pushReview') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.REJECTED, StatusEnum.DRAFT])) {
          this.$gjMessage.warning("草稿、已驳回下的采购计划才能提审！")
          return false;
        }
        this.pushReview(this.selectedRows);
      } else if (this.batchOperate === 'pass') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)) {
          this.$gjMessage.warning("待审核状态下的采购计划才能审核!")
          return false;
        }
        this.batchPass(this.selectedRows);
      } else if (this.batchOperate === 'reject') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)) {
          this.$gjMessage.warning("待审核状态下的采购计划才能审核!")
          return false;
        }
        this.batchReject(this.selectedRows, this.batchOperate);
      } else if (this.batchOperate === 'invalid') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED, StatusEnum.WAIT_HANDLE])) {
          this.$gjMessage.warning("待审核、已驳回、待处理状态的采购计划才能作废!")
          return false;
        }
        this.batchReject(this.selectedRows, this.batchOperate);
      } else if (this.batchOperate === 'del') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeIsNot('status', StatusEnum.DRAFT)) {
          this.$gjMessage.warning("草稿状态的采购计划才能删除!")
          return false;
        }
        this.batchDelete(this.selectedRows);
      }
    },
  }
}
</script>

<style scoped lang="scss">
.redColor {
  color: red;
}

.gj-upload-text {
  /deep/ .el-button--text {
    font-size: 12px !important;
  }
}

.urgent-text {
  display: inline-block;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #FFFFFF;
  width: 20px;
  height: 20px;
  background: #F25555;
  border-radius: 2px;
}

.type-text {
  display: inline-block;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  color: #1F6EEF;
  width: 20px;
  height: 20px;
  background: #EFF5FF;
  border-radius: 2px;
}

/deep/ .el-popover {
  padding: 0 !important;
}

/deep/ .gj-popover {
  background: #FFFFFF;
  box-shadow: 0 4px 24px -8px rgba(0, 0, 0, 0.5);
  padding: 0 !important;;
}

.popover-content {
  font-size: 12px;
  color: #333333;
  line-height: 26px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 16px;
  margin: -10px -12px;
}

.title-span {
  color: #999999;
}

.popover-content:hover {
  background: #F2F7FF;
  color: #1F6EEF;
  cursor: pointer;
}

.selected-active {
  /deep/ .el-input__inner {
    &::placeholder {
      color: #333333;
    }
  }

}

.iconfont {
  font-size: 10px;
  color: #999;
}

.iconshouqi {
  margin-left: 5px;
}

.purchase-plan-accessory {
  /deep/ .gj-upload {
    padding-top: 4px;
  }

  /deep/ .el-button--small {
    padding: 0;
  }
}
.default {
   /deep/ .gj-link{
    &:hover{
      .iconfont{
        color: #1F6EEF;
      }
    }
  }
}
</style>
